import { BulkAddClientRecord } from '../types';

export const columnWidths: Record<keyof BulkAddClientRecord, number> = {
    clientFirstName: 140,
    clientLastName: 160,
    clientDOB: 200,
    clientPreferredName: 160,
    pointOfContactPhoneNumber: 340,
    pointOfContactEmail: 300,
    pointOfContactFirstName: 200,
    pointOfContactLastName: 220,
    pointOfContactPreferredName: 240,
};
